import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ICustomerGenericService, IHIPGenericService, TeltonikaIPs } from '@huge-monorepo/shared/interfaces';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService, SharedGenericSingletonService } from '@huge-monorepo/shared/services';
import { MatDialog } from '@angular/material/dialog';
import { TeltonikaCopySSHModalComponent } from '../../modals/teltonika-copy-ssh-modal/TeltonikaCopySSHModal.component';
import { SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { IHIPTeltonikaService, ICustomerTeltonikaService } from '@huge-monorepo/shared/interfaces';
import { Terminal } from '@xterm/xterm';
import { FitAddon } from '@xterm/addon-fit';
import { AttachAddon } from '@xterm/addon-attach';
import { TeltonikaSshLogInModalComponent } from '../../modals/teltonika-ssh-log-in-modal/teltonika-ssh-log-in-modal.component';
import { Subscription } from 'rxjs';
import { SideNavToggleService } from '@huge-monorepo/hip/services';

@Component({
  selector: 'huge-monorepo-teltonika-device-remote-access',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './teltonika-device-remote-access.component.html',
  styleUrl: './teltonika-device-remote-access.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class TeltonikaDeviceRemoteAccessComponent implements OnInit, OnDestroy {
  id: number;
  loading: boolean = false;
  ips: TeltonikaIPs | null = null;
  displayTerminal: boolean = false;
  public term: Terminal;
  socket: WebSocket;
  @ViewChild('myTerminal') terminalDiv: ElementRef;
  dialogSub: Subscription;
  terminalLoading: boolean = false;
  controlsLoading: boolean = false;
  fitAddon: FitAddon;
  isHip: boolean = this.genericSingleton.getIsHIP();

  constructor(
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private activatedRoute: ActivatedRoute,
    private genericSingleton: SharedGenericSingletonService<ICustomerGenericService | IHIPGenericService>,
    private router: Router,
    private sideNavToggleService: SideNavToggleService,
  ) { }

  ngOnDestroy(): void {
    if (this.socket)
      this.socket.close(1000);
  }

  ngOnInit(): void {
    this.loading = true;
    this.activatedRoute.paramMap.subscribe(
      (paraMap: any) => {
        if (paraMap.params.id) {
          let id = paraMap.params.id;
          this.id = id;
          this.fetchData(id);
        }
      }
    );
  }

  /**
   * @description Fetch the IP addresses of the device
   * @param id The device ID
   */
  fetchData(id: number) {
    this.sharedTeltonikaService.service.getDeviceIPs(id).subscribe({
      next: (data) => {
        this.ips = data;
      },
      complete: () => {
        this.loading = false;
      }
    });
  }


  /**
   * @description Open HTTP tunnel
   * @param ip The IP address to open the tunnel to
   */
  openHTTP(ip: string) {

    this.controlsLoading = true;

    this.sharedTeltonikaService.service.startTeltonikaTunneling(this.id, 80, ip).subscribe({
      next: (data) => {
        this.controlsLoading = false;
        if(this.isHip) {
          if(this.sideNavToggleService.openOrClosed()) {
            this.sideNavToggleService.toggle();
          }
        }
        window.open(`http://${data}`, "_blank");
        this.sideNavToggleService.toggle();
      },
      error: (error) => {
        this.genericSingleton.service.createToast('Error', 'Failed to open HTTP tunnel', 'error');
        this.loading = false;
      },

    });
  }

  /**
   * @description Open SSH tunnel
   * @param ip The IP address to open the tunnel to
   */
  openSSH(ip: string) {
    // THIS IS THE CODE FOR A SMALL IN-SCREEN TERMINAL, DO NOT REMOVE YET
    // const dialogRef = this.dialog.open(TeltonikaSshLogInModalComponent, {
    //   width: '800px',
    //   maxHeight: '60vh',
    //   data: { address: ip }
    // });

    // this.displayTerminal = false;
    // this.terminalLoading = true;

    // this.dialogService.RegisterDialog(dialogRef);
    // this.dialogSub = dialogRef.afterClosed().subscribe((result) => {
    //   this.dialogService.DeRegisterDialog(dialogRef);
    //   this.dialogSub.unsubscribe();
    //   if (result != null && result.username != null && result.password != null) {

    //     this.startTerminal(ip, result.username, result.password);
    //   } else {
    //     this.terminalLoading = false;
    //   }
    // });
    if(this.isHip) {
      if(this.sideNavToggleService.openOrClosed()) {
        this.sideNavToggleService.toggle();
      }
    }

    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/Teltonika/terminal/${this.id}/${encodeURIComponent(ip)}`])
    );
    window.open(url, '_blank');
    this.sideNavToggleService.toggle();
  }

  startTerminal(ip: string, username: string, password: string) {
    this.displayTerminal = true;
    this.terminalLoading = false;
    this.term = new Terminal({
      cursorBlink: true,
      theme: {
        background: '#212121',
        foreground: '#c9c9c9',
      }
    });
    this.fitAddon = new FitAddon();

    this.term.loadAddon(this.fitAddon);

    setTimeout(() => {
      const url: string = this.sharedTeltonikaService.service.getTeltonikaRemoteAccessWebsocketURL(this.id, ip, this.term.rows, this.term.cols, username, password);
      this.socket = new WebSocket(url);

      const attachAddon = new AttachAddon(this.socket);
      this.term.loadAddon(attachAddon);

      this.socket.onmessage = (e: MessageEvent) => {
      };

      this.socket.onerror = (error) => {
        this.displayTerminal = false;
        this.terminalLoading = false;
        this.socket.close(1000);
      };

      this.socket.onclose = (data) => {

        if (data != null && data.reason != null && data.reason.startsWith("ERR:")) {
          if (data.reason.startsWith("ERR:ssh: handshake failed: ssh: unable to authenticate")) {
            this.genericSingleton.service.createToast('Error', 'Authentication failed. Please check the username and password and try again.', 'error');
            this.displayTerminal = false;
            this.openSSH(ip);
          } else {
            this.term.writeln("Error in Terminal connection: " + data.reason);
          }
        } else {
          this.term.writeln('');
          this.term.writeln(data.reason);
        }
        this.term.writeln('Connection closed');
      };

      this.socket.onopen = () => {

        this.term.open(this.terminalDiv.nativeElement);

        this.fitAddon.fit();

        this.term.writeln('Attempting to connect with username: root');

        this.term.onKey((e) => { });
      };

    });
  }
}
